/* eslint-disable id-length */
// GitHub language colors mapping
// Based on https://github.com/ozh/github-colors

export const LANGUAGE_COLORS: Record<string, string> = {
  "1C Enterprise": "#814CCC",
  ABAP: "#E8274B",
  "ABAP CDS": "#555e25",
  ActionScript: "#882B17",
  Ada: "#02f88c",
  Agda: "#315665",
  "AGS Script": "#B9D9FF",
  AL: "#3AA2B5",
  Alloy: "#64C800",
  AMPL: "#E6EFBB",
  AngelScript: "#C7D7DC",
  ANTLR: "#9DC3FF",
  APL: "#5A8164",
  AppleScript: "#101F1F",
  Arc: "#aa2afe",
  "ASP.NET": "#9400ff",
  AspectJ: "#a957b0",
  Assembly: "#6E4C13",
  Astro: "#FF5A03",
  ATS: "#1ac620",
  AutoHotkey: "#6594b9",
  AutoIt: "#1C3552",
  Ballerina: "#FF5000",
  BASIC: "#ff0000",
  Batchfile: "#C1F12E",
  Berry: "#15A13C",
  Bicep: "#519aba",
  Blade: "#f7523f",
  BlitzBasic: "#00FFAE",
  BlitzMax: "#cd6400",
  Boo: "#d4bec1",
  Brainfuck: "#2F2530",
  Brightscript: "#662D91",
  BrighterScript: "#66AABB",
  C: "#555555",
  "C#": "#178600",
  "C++": "#f34b7d",
  "Cabal Config": "#483465",
  Cairo: "#ff4a48",
  CameLIGO: "#3be133",
  "Cap'n Proto": "#c42727",
  Carbon: "#515515",
  Ceylon: "#dfa535",
  Chapel: "#8dc63f",
  ChucK: "#3f8000",
  Circom: "#707575",
  Cirru: "#ccccff",
  Clarion: "#db901e",
  "Classic ASP": "#6a40fd",
  Clean: "#3F85AF",
  Click: "#E4E6F3",
  CLIPS: "#00A300",
  Clojure: "#db5855",
  CMake: "#DA3434",
  COBOL: "#F4C430",
  CodeQL: "#140f46",
  CoffeeScript: "#244776",
  ColdFusion: "#ed2cd6",
  "ColdFusion CFC": "#ed2cd6",
  "Common Lisp": "#3fb68b",
  "Common Workflow Language": "#B5314C",
  "Component Pascal": "#B0CE4E",
  Crystal: "#000100",
  CSS: "#563d7c",
  Cuda: "#3A4E6A",
  Cython: "#fedf5b",
  D: "#ba595e",
  Dart: "#00B4FF",
  DataWeave: "#003a52",
  Dhall: "#dfafff",
  DM: "#447265",
  Dockerfile: "#384d54",
  Dogescript: "#cca760",
  Dylan: "#6c616e",
  E: "#ccce35",
  Earthly: "#2af0ff",
  eC: "#913960",
  ECL: "#8a1267",
  Eiffel: "#4d6977",
  EJS: "#a91e50",
  Elixir: "#6e4a7e",
  Elm: "#60B5CC",
  "Emacs Lisp": "#c065db",
  EmberScript: "#FFF4F3",
  EQ: "#a78649",
  Erlang: "#B83998",
  "F#": "#b845fc",
  "F*": "#572e30",
  Factor: "#636746",
  Fancy: "#7b9db4",
  Fantom: "#14253c",
  Fennel: "#fff3d7",
  FIRRTL: "#3f0d0d",
  fish: "#4aae47",
  Fluent: "#ffcc33",
  FLUX: "#88ccff",
  Forth: "#341708",
  Fortran: "#4d41b1",
  FreeBASIC: "#867db1",
  FreeMarker: "#0050b2",
  Frege: "#00cafe",
  Futhark: "#5f021f",
  "G-code": "#D08CF2",
  "Game Maker Language": "#71b417",
  GAML: "#FFC766",
  GAMS: "#f49a22",
  GAP: "#0000cc",
  GDScript: "#355570",
  GDShader: "#355570",
  Genie: "#fb8500",
  Genshi: "#951531",
  Gherkin: "#5B2063",
  Gleam: "#ffaff3",
  "Glimmer JS": "#f5835f",
  "Glimmer TS": "#f5835f",
  GLSL: "#5686a5",
  Gnuplot: "#f0a9f0",
  Go: "#00ADD8",
  Golo: "#88562A",
  Gosu: "#82937f",
  Grace: "#615f8b",
  Gradle: "#02303a",
  "Grammatical Framework": "#ff0000",
  GraphQL: "#e10098",
  "Graphviz (DOT)": "#2596be",
  Groovy: "#e69f56",
  Hack: "#878787",
  Haml: "#ece2a9",
  Handlebars: "#f7931e",
  Harbour: "#0e60e3",
  Haskell: "#5e5086",
  Haxe: "#df7900",
  HCL: "#844fba",
  HLSL: "#aace60",
  HOCON: "#9ff8ee",
  HolyC: "#ffefaf",
  HTML: "#e34c26",
  Hy: "#7790b2",
  IDL: "#a3522f",
  Idris: "#b30000",
  "IGOR Pro": "#0000cc",
  "ImageJ Macro": "#99AAFF",
  Imba: "#16cec6",
  Io: "#a9188d",
  Ioke: "#078193",
  Isabelle: "#FEFE00",
  J: "#9EEDFF",
  Java: "#b07219",
  JavaScript: "#f1e05a",
  "Jest Snapshot": "#15c213",
  "JetBrains MPS": "#21D789",
  JFlex: "#DBCA00",
  Jinja: "#a52a22",
  Jison: "#56b3cb",
  "Jison Lex": "#56b3cb",
  Jolie: "#843179",
  jq: "#c7254e",
  JSON: "#292929",
  JSON5: "#267CB9",
  JSONiq: "#40d47e",
  Jsonnet: "#0064bd",
  Julia: "#a270ba",
  "Jupyter Notebook": "#DA5B0B",
  KakouneScript: "#6f8042",
  KerboScript: "#41adf0",
  Kotlin: "#F18E33",
  KRL: "#28431f",
  LabVIEW: "#fede06",
  Lark: "#2980B9",
  Lasso: "#999999",
  Latte: "#f2a542",
  Lean: "#72d0e2",
  Less: "#1d365d",
  LFE: "#4C3023",
  LigoLANG: "#0e74ff",
  LilyPond: "#9ccc7c",
  Liquid: "#67b8de",
  "Literate Agda": "#315665",
  "Literate CoffeeScript": "#244776",
  "Literate Haskell": "#5e5086",
  LiveScript: "#499886",
  LLVM: "#185619",
  LOLCODE: "#cc9900",
  LookML: "#652B81",
  LSL: "#3d9970",
  Lua: "#000080",
  Luau: "#00a2ff",
  M: "#62d543",
  Makefile: "#427819",
  Mako: "#7e858d",
  Markdown: "#083fa1",
  Marko: "#42bff2",
  Mathematica: "#dd1100",
  MATLAB: "#e16737",
  Max: "#c4a79c",
  MAXScript: "#00a6fb",
  mcfunction: "#E22837",
  MDX: "#fcb32c",
  Mercury: "#ff2b2b",
  Mermaid: "#ff3670",
  Meson: "#007800",
  Metal: "#8f14e9",
  MiniYAML: "#ff1414",
  Mirah: "#c7a938",
  "mIRC Script": "#3d57c3",
  MLIR: "#5EC8DB",
  Modelica: "#de1d31",
  "Modula-2": "#10253f",
  "Modula-3": "#223388",
  Mojo: "#ff4c1f",
  MoonScript: "#ff4585",
  Motoko: "#fbb03b",
  Move: "#4a137a",
  MQL4: "#62A8D6",
  MQL5: "#4A76B8",
  MTML: "#b7e1f4",
  Mustache: "#724b3b",
  Nasal: "#1d2c4e",
  NCL: "#28431f",
  Nearley: "#990000",
  Nemerle: "#3d3c6e",
  nesC: "#94B0C7",
  NetLinx: "#0aa0ff",
  "NetLinx+ERB": "#747faa",
  NetLogo: "#ff6375",
  NewLisp: "#87AED7",
  Nextflow: "#3ac486",
  Nginx: "#9469E8",
  Nim: "#ffc200",
  Nit: "#009917",
  Nix: "#7e7eff",
  NSIS: "#dfe9f2",
  "Objective-C": "#438eff",
  "Objective-C++": "#6866fb",
  "Objective-J": "#ff0c5a",
  ObjectScript: "#424893",
  OCaml: "#3be133",
  Odin: "#60AFFE",
  Omgrofl: "#cabbff",
  ooc: "#b0b77e",
  Opal: "#f7ede0",
  "Open Policy Agent": "#7d9199",
  "OpenAPI Specification v2": "#85ea2d",
  "OpenAPI Specification v3": "#85ea2d",
  OpenCL: "#ed2e2d",
  "OpenEdge ABL": "#5ce600",
  OpenQASM: "#AA70FF",
  OpenSCAD: "#e5cd45",
  Org: "#77AA99",
  Oz: "#fab738",
  P4: "#7055b5",
  Pan: "#cc0000",
  Papyrus: "#6600cc",
  Parrot: "#f3ca0a",
  Pascal: "#E3F171",
  Pawn: "#dbb284",
  "PEG.js": "#234d6b",
  Perl: "#0298c3",
  PHP: "#4F5D95",
  PicoLisp: "#6067af",
  PigLatin: "#fcd7de",
  Pike: "#005390",
  PLSQL: "#dad8d8",
  PogoScript: "#d80074",
  Polar: "#ae81ff",
  Pony: "#332985",
  PostCSS: "#dc3a0c",
  PostScript: "#da291c",
  PowerBuilder: "#8f0f8d",
  PowerShell: "#012456",
  Prisma: "#0c344b",
  Processing: "#0096D8",
  Prolog: "#74283c",
  "Propeller Spin": "#7fa2a7",
  Puppet: "#302B6D",
  PureBasic: "#5a6986",
  PureScript: "#1D222D",
  Python: "#3572A5",
  "Q#": "#fed659",
  QML: "#44a51c",
  "Qt Script": "#00b841",
  Quake: "#882233",
  R: "#198CE7",
  Racket: "#3c5caa",
  Ragel: "#9d5200",
  Raku: "#0000fb",
  RAML: "#77d9fb",
  Rascal: "#fffaa0",
  RBS: "#701516",
  Reason: "#ff5847",
  ReasonLIGO: "#ff5847",
  Rebol: "#358a5b",
  Red: "#f50000",
  "Ren'Py": "#ff7f7f",
  ReScript: "#ed5051",
  reStructuredText: "#141414",
  REXX: "#d90e09",
  Ring: "#2D54CB",
  Roc: "#7c38f5",
  Roff: "#ecdebe",
  Rouge: "#cc0088",
  Ruby: "#701516",
  Rust: "#dea584",
  SAS: "#B34936",
  Sass: "#a53b70",
  Scala: "#c22d40",
  Scheme: "#1e4aec",
  SCSS: "#c6538c",
  sed: "#64b970",
  Self: "#0579aa",
  ShaderLab: "#222c37",
  Shell: "#89e051",
  Shen: "#120F14",
  Slash: "#007eff",
  Slice: "#003fa2",
  Slim: "#2b2b2b",
  Smalltalk: "#596706",
  Smarty: "#f0c040",
  Solidity: "#AA6746",
  SourcePawn: "#f69e1d",
  SPARQL: "#0C4597",
  SQF: "#3F3F3F",
  SQL: "#e38c00",
  SQLPL: "#e38c00",
  Squirrel: "#800080",
  "SRecode Template": "#348a34",
  Stan: "#b2011d",
  "Standard ML": "#dc566d",
  Starlark: "#76d275",
  Stata: "#1a5490",
  STL: "#373b5e",
  Stylus: "#ff6347",
  SuperCollider: "#46390b",
  Svelte: "#ff3e00",
  SVG: "#ff9900",
  Swift: "#FA7343",
  SystemVerilog: "#DAE1C2",
  Tcl: "#e4cc98",
  Terra: "#00004c",
  TeX: "#3D6117",
  Thrift: "#D12127",
  "TI Program": "#A0AA87",
  TLA: "#4b0079",
  TOML: "#9c4221",
  TSQL: "#e38c00",
  TSX: "#2b7489",
  Turing: "#cf142b",
  Twig: "#c1d026",
  TypeScript: "#2b7489",
  Uno: "#9933cc",
  UnrealScript: "#a54c4d",
  UrWeb: "#ccccee",
  V: "#4f87c4",
  Vala: "#fbe5cd",
  VBA: "#867db1",
  VBScript: "#15dcdc",
  VCL: "#148AA8",
  Verilog: "#b2b7f8",
  VHDL: "#adb2cb",
  "Vim Script": "#199f4b",
  "Visual Basic .NET": "#945db7",
  "Visual Basic 6.0": "#2c6353",
  Volt: "#1F1F1F",
  Vue: "#42b883",
  Vyper: "#2980b9",
  wdl: "#42f1f4",
  WebAssembly: "#04133b",
  Whiley: "#d5c397",
  Wren: "#383838",
  X10: "#4B6BEF",
  xBase: "#403a40",
  XC: "#99DA07",
  XML: "#0060ac",
  Xojo: "#81bd41",
  XQuery: "#5232e7",
  XSLT: "#EB8CEB",
  Xtend: "#24255d",
  Yacc: "#4B6C4B",
  YAML: "#cb171e",
  YARA: "#220000",
  YASnippet: "#32AB90",
  ZAP: "#0d665e",
  Zeek: "#3b1f1f",
  ZenScript: "#00BCD1",
  Zephir: "#118f9e",
  Zig: "#ec915c",
  ZIL: "#dc75e5",
  Zimpl: "#d67711",
};

/**
 * Get the color for a programming language
 * @param language - The programming language name
 * @returns The hex color code for the language, or a default gray if not found
 */
export function getLanguageColor(language: string | null | undefined): string {
  if (!language) {
    return "#6b7280"; // gray-500 default
  }

  return LANGUAGE_COLORS[language] || "#6b7280";
}
